import React, { useState } from "react";
import { TspCard, TspToggleGroup, TspLineChart } from "../../../components/primitives";

const RANGE_OPTIONS = [
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
  { value: "yearly", label: "Yearly" },
];

export default function BookDistributionOverview({ overview }) {
  const [range, setRange] = useState("monthly");
  const data = overview[range];
  const peakPoint = range === "monthly" ? overview.peak : null;

  return (
    <TspCard
      title="Book Distribution Overview"
      action={<TspToggleGroup options={RANGE_OPTIONS} value={range} onChange={setRange} />}
    >
      <TspLineChart
        data={data}
        xKey="period"
        series={[
          { key: "actual", name: "Actual", color: "#9F1D21" },
          { key: "target", name: "Target", color: "#9AA3B2", dashed: true },
        ]}
        peak={peakPoint}
      />
      <div className="tsp-chip-row">
        <span className="tsp-chip tsp-chip-pink">Total {overview.totals.totalBooks}</span>
        <span className="tsp-chip tsp-chip-blue">{overview.totals.citiesCovered}</span>
        <span className="tsp-chip tsp-chip-green">{overview.totals.statesCovered}</span>
      </div>
    </TspCard>
  );
}
